<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <el-col :span="2" :offset="22">
          <el-button @click="add" size="mini">新建洗美</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="listLine">
      <el-table :data="tableData" height="100%" style="width: 100%">
        <el-table-column label="单号" width="95">
          <template slot-scope="scope">
            <span>{{ scope.row.washRecordId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目" width="180">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.goodsNames"
              :key="item + index"
            >
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="宠物">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.petList"
              :key="item.petName + index"
            >
              <el-button
                v-if="
                  !$public.isNull(item.contractNum) &&
                  item.isCompleteInfo === false &&
                  shopId === scope.row.shopId
                "
                type="primary"
                @click="edit(item)"
                style="margin-right: 2px; margin-bottom: 2px"
                size="mini"
                >完善信息</el-button
              >
              {{ item.petName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="总计" width="70">
          <template slot-scope="scope">
            {{ scope.row.totalMoney }}
          </template>
        </el-table-column>
        <el-table-column label="创建人" width="80">
          <template slot-scope="scope">
            {{ scope.row.createUserName }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="115">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.createTime, "YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="65">
          <template slot-scope="scope">
            <span v-if="scope.row.isPay === false" style="color: red"
              >待支付</span
            >
            <span v-else>
              {{ scope.row.status === 1 ? "进行中" : "已完成" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="see(scope.row)"
              style="margin-right: 5px"
              >查看</el-button
            >
            <!-- /api/WashBeauty/SendContract -->
            <span v-if="scope.row.isPay === false" style="margin-right: 5px">
              <el-button type="text" @click="pay(scope.row)">结算</el-button>
              <el-button type="text" @click="cancel(scope.row)">取消</el-button>
            </span>
            <span v-else style="margin-right: 5px">
              <el-button
                v-if="scope.row.status === 1 && shopId === scope.row.shopId"
                type="text"
                @click="complete(scope.row)"
                >完成</el-button
              >
            </span>
            <el-button
              v-if="
                shopId === scope.row.shopId &&
                scope.row.sendSignContractState === 2
              "
              type="text"
              @click="send(scope.row)"
              style="margin-right: 5px"
              >发送</el-button
            >
            <el-button
              v-if="
                shopId === scope.row.shopId &&
                scope.row.sendSignContractState === 3
              "
              type="text"
              @click="reSend(scope.row)"
              style="margin-right: 5px"
              >重新发送</el-button
            >
          </template>
        </el-table-column>
        <span slot="empty">
          <img
            src="../../../../assets/img/konging.png"
            style="width: 271px; margin-top: 100px"
          />
          <div style="font-size: 16px; color: #999; margin: 20px">
            这个人什么痕迹都没留下
          </div>
        </span>
      </el-table>
    </div>
    <div class="pageLine">
      <page
        :page="page.page"
        :pageSize="page.pageSize"
        :total="page.total"
        @change="changePage"
      ></page>
    </div>
    <ximeiSee
      v-if="drawerSee_state"
      :curItem="curItem"
      @submit="submit_drawerSee"
    ></ximeiSee>
    <!-- 备注弹窗 -->
    <div v-if="drawerComplete_state">
      <drawerXimeiComplete
        :curItem="curItem"
        @submit="submit_Complete"
      ></drawerXimeiComplete>
    </div>
    <!-- 结算 -->
    <div v-if="dialogSettlement_state">
      <dialogSettlement
        :orderId="curItem.orderNum"
        @submit="submit_dialogSettlement"
      ></dialogSettlement>
    </div>
    <!-- 完善信息 -->
    <div v-if="dialogEdit_state">
      <ximeiChangeEdit
        :curPet="curPet"
        @submit="submit_dialogEdit"
      ></ximeiChangeEdit>
    </div>
  </div>
</template>
<script>
import page from "../../../../components/page.vue";
import ximeiSee from "../drawer/ximeiSee.vue";
import ximeiChangeEdit from "../drawer/ximeiChangeEdit.vue";
import drawerXimeiComplete from "../drawer/ximeiComplete.vue";
import dialogSettlement from "../../../../components/dialog_settlement.vue";
export default {
  components: {
    page,
    ximeiSee,
    ximeiChangeEdit,
    drawerXimeiComplete,
    dialogSettlement,
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      // see
      drawerSee_state: false,
      curItem: {},
      // complete
      drawerComplete_state: false,
      // 结算
      dialogSettlement_state: false,
      // 完善信息
      dialogEdit_state: false,
      curPet: {},
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    shopId() {
      return this.$store.state.shopId;
    },
  },
  watch: {
    curPetInfo() {
      this.getTableData();
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    add() {
      this.$store.commit("ximei/set_type", "add");
    },
    see(row) {
      this.drawerSee_state = true;
      this.curItem = row;
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
      this.getTableData();
    },
    complete(row) {
      this.see(row);
    },
    cancel(row) {
      this.$confirm("确定取消吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          order_id: row.orderNum,
        };
        let loading = this.$loading();
        this.$http.get("api/Order/ReceivedOrder", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.getTableData();
          }
        });
      });
    },
    pay(row) {
      this.curItem = row;
      this.dialogSettlement_state = true;
    },
    // 结算
    submit_dialogSettlement(a) {
      this.dialogSettlement_state = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
      }
      this.getTableData();
    },
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 获取寄养列表
    getTableData() {
      let params = {
        memberId: this.userInfo._id,
        petId: this.curPetId,
        shopId: "",
        status: 0, // 0不限；1进行中；2已完成
        isPay: -1,
        startTime: "",
        endTime: "",
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: "",
      };
      let loading = this.$loading();
      this.$http.post("/api/WashBeauty/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
    // 发送
    reSend(item) {
      this.$confirm(
        "重新发送将会覆盖已经存在的合同，请谨慎操作。确定要重新发送吗?",
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.send(item);
      });
    },
    send(item) {
      let params = {
        washBeautyId: item.washRecordId,
        orderNum: item.orderNum,
      };
      let loading = this.$loading();
      this.$http.get("/api/WashBeauty/SendContract", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getTableData();
        }
      });
    },
    edit(petItem) {
      this.curPet = petItem;
      this.dialogEdit_state = true;
    },
    submit_dialogEdit(obj) {
      this.dialogEdit_state = false;
      if (obj.type == "close") {
        console.log(close);
      } else if (obj.type == "success") {
        this.getTableData();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  background-color: #fff;
  padding: 40px 0 0;
  box-sizing: border-box;
  position: relative;
  .titleLine {
    width: 100%;
    background-color: #fff;
    padding: 8px 8px 8px;
    box-sizing: border-box;
    margin-bottom: 4px;
    position: absolute;
    top: 0;
  }
  .listLine {
    height: 100%;
    padding: 0 10px 60px 10px;
    box-sizing: border-box;
  }
  .pageLine {
    position: absolute;
    bottom: 0;
    z-index: 1;
    width: 100%;
    padding: 10px;
    background-color: #fff;
    box-sizing: border-box;
  }
}
</style>
